import { render, staticRenderFns } from "./ReCalendar.vue?vue&type=template&id=0313edd1"
import script from "./ReCalendar.vue?vue&type=script&lang=js"
export * from "./ReCalendar.vue?vue&type=script&lang=js"
import style0 from "./ReCalendar.vue?vue&type=style&index=0&id=0313edd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports